/**
 * @typedef {Object} ToggleProps
 * @property {boolean} checked - Whether the toggle is on
 * @property {(checked: boolean) => void} [onChange] - Called when toggle is clicked
 * @property {boolean} [disabled] - Whether the toggle is disabled
 * @property {string} [className] - Additional CSS class
 */

/**
 * Toggle switch component with pill-shaped track and circular knob.
 *
 * @param {ToggleProps} props - Component props
 * @returns {JSX.Element} The toggle switch component
 */
export default function Toggle({ checked, onChange, disabled = false, ...props }) {
  checked = !!checked
  disabled = !!disabled

  const { className } = props

  const classNames = ["da-toggle"]
  if (checked) classNames.push("da-toggle-checked")
  if (disabled) classNames.push("da-toggle-disabled")
  if (className != null) classNames.push(className)

  const handleOnClick = () => {
    if (disabled || !onChange) {
      return
    }

    onChange(!checked)
  }

  return (
    <div
      className={classNames.join(" ")}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      onClick={handleOnClick}
    >
      <div className="da-toggle-track">
        <div className="da-toggle-knob" />
      </div>
    </div>
  )
}
